import { useAuth0 } from '@auth0/auth0-react';

import { useIsFeatureOn } from 'hooks/useFeatureSwitch/useIsFeatureOn';

export function useSurveyEnabled(): boolean {
  const { features } = useIsFeatureOn();
  const { user } = useAuth0();

  const feature = features?.find(f => f.name === 'plg_survey');

  // If feature is globally enabled
  if (feature?.enabled) {
    return true;
  }

  // Check if user is whitelisted
  if (user?.email && feature?.whitelist?.users?.includes(user.email)) {
    return true;
  }

  return false;
}
